import step1Image from '../assets/bracket-tutorial/1.content.png'
import step2Image from '../assets/bracket-tutorial/2.pdfusage.png'
import step3Image from '../assets/bracket-tutorial/3.signerExmp.png'
import step4Image from '../assets/bracket-tutorial/4.signeriput.png'
import step5Image from '../assets/bracket-tutorial/5.signeraftersigned.png'

export { step1Image, step2Image, step3Image, step4Image, step5Image }

export const BRACKET_FIELD_TUTORIAL_IMAGES = [step1Image, step2Image, step3Image, step4Image, step5Image]
